import { RFI_ENV_CONFIG_KEYS, statusColorMapping } from './consts';
import getEnvConfig from './helpers/getEnvConfig';

export const getStatusFromServerStatus = serverStatus => {
  return serverStatus.replace(new RegExp(/(Rev1|Rev2)$/), '').replace(new RegExp(/(Manager)$/), '');
};

const getPropsFromEntity = ({ entity, env, region, projectId, T }) => {
  const { id, status: serverStatus, title, identifier, customIdentifier } = entity;
  const entityIdentifier = identifier || customIdentifier;
  const userFriendlyId = entityIdentifier ? `#${entityIdentifier}` : '';
  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    RFI_ENV_CONFIG_KEYS.PJM_FE
  )}/projects/${projectId}/rfis/?preview=${id}`;

  const status = getStatusFromServerStatus(serverStatus);
  const statusColor = status ? statusColorMapping[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;
  return {
    entityTypeName: T.translate('RFI'),
    title,
    userFriendlyId,
    deeplinkUrl,
    statusColor,
    statusText
  };
};

export default getPropsFromEntity;
